import {
    MENS_MAGAZINE_CONFIRM_COMPONENT,
    MENS_MAGAZINE_LINKAGE_ID,
    MENS_MAGAZINE_PROFILE_COMPONENT,
    MENS_MAGAZINE_SITE_UNIQ_API_PATH, MENS_MAGAZINE_WITHDRAW_CUSTOM_COMPONENT,
    WEEKLY_PLAYBOY_ACCEPT_CALLBACK_URLS,
    WEEKLY_PLAYBOY_DEFAULT_CALLBACK_URL,
    WEEKLY_PLAYBOY_EMAIL_DOMAINS, WEEKLY_PLAYBOY_LINKAGE_NAME, WEEKLY_PLAYBOY_LINKAGE_SUB_ID, WEEKLY_PLAYBOY_PATH,
    WEEKLY_PLAYBOY_SERVICE_TERM_URL
} from "@/commons/linkage/sites/weeklyPlayboy";
import { createLinkageRoute, linkageBeforeEach, linkageScrollBehavior } from "@/router/linkage";
import { createRouter, createWebHistory } from "vue-router";

// 週プレ画面用ルート定義
const routes = createLinkageRoute(
    MENS_MAGAZINE_LINKAGE_ID,
    WEEKLY_PLAYBOY_LINKAGE_NAME,
    WEEKLY_PLAYBOY_PATH,
    MENS_MAGAZINE_SITE_UNIQ_API_PATH,
    WEEKLY_PLAYBOY_DEFAULT_CALLBACK_URL,
    WEEKLY_PLAYBOY_ACCEPT_CALLBACK_URLS,
    WEEKLY_PLAYBOY_SERVICE_TERM_URL,
    WEEKLY_PLAYBOY_EMAIL_DOMAINS,
    MENS_MAGAZINE_PROFILE_COMPONENT,
    MENS_MAGAZINE_CONFIRM_COMPONENT,
    {
        linkageSubId: WEEKLY_PLAYBOY_LINKAGE_SUB_ID,
        withDrawCustomComponent: MENS_MAGAZINE_WITHDRAW_CUSTOM_COMPONENT,
    }
);

// 週プレ画面用ルータ作成
const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    scrollBehavior: linkageScrollBehavior,
    routes: routes,
});

// beforeEach
router.beforeEach(linkageBeforeEach);

// 週プレ画面用ルータ
export const weeklyPlayboyRouter = router;
